import graphqlClient from './graphqlClient';

export interface NoteAuditLogEntry {
  id: string;
  entityId: string;
  action: 'note_added' | 'note_edited' | 'note_deleted';
  oldValue: string | null;
  newValue: string | null;
  timestamp: string;
  user: { id: string; name: string } | null;
}

interface RawAuditLogRow {
  id: string;
  entity_id: string;
  action: string;
  old_value: string | null;
  new_value: string | null;
  user_id: string;
  timestamp: string;
}

/**
 * Resolve the acting user's display name for each raw app.audit_log row.
 * audit_log.user_id is text (not a real FK), so this is a plain follow-up
 * lookup rather than a Hasura relationship.
 */
export const resolveAuditLogUsers = async (rows: RawAuditLogRow[]): Promise<NoteAuditLogEntry[]> => {
  if (rows.length === 0) return [];

  const userIds = Array.from(new Set(rows.map((r) => r.user_id)));
  const usersQuery = `
    query GetUsersByIds($ids: [uuid!]!) {
      app_user(where: { id: { _in: $ids } }) {
        id
        name
      }
    }
  `;
  const usersResponse = await graphqlClient.request<{
    app_user: { id: string; name: string }[];
  }>(usersQuery, { ids: userIds });
  const userMap = new Map(usersResponse.app_user.map((u) => [u.id, u]));

  return rows.map((r) => ({
    id: r.id,
    entityId: r.entity_id,
    action: r.action as NoteAuditLogEntry['action'],
    oldValue: r.old_value,
    newValue: r.new_value,
    timestamp: r.timestamp,
    user: userMap.get(r.user_id) ?? null
  }));
};
